<span class="ui-toast__message">{{ data.message }}</span>
<button type="button" class="ui-toast__close" aria-label="Dismiss" (click)="dismiss()">
  <mat-icon>close</mat-icon>
</button>
